// app/javascript/landing/pages/SomosPage.tsx
import React from "react";
import { SmartImage } from "../components/SmartImage";

type TeamMember = {
  name: string;
  role: string;
  title: string;
  photo: string;
};

const team: TeamMember[] = [
  {
    name: "Joaquín González",
    role: "CEO",
    title: "Arquitecto",
    photo: "/landing/team/joaquin-gonzalez.png",
  },
  {
    name: "Alastair Aguilera",
    role: "CPO",
    title: "Arquitecto",
    photo: "/landing/team/alastair-aguilera.png",
  },
  {
    name: "Magdalena García",
    role: "Project management",
    title: "Arquitecta",
    photo: "/landing/team/magdalena-garcกa.png",
  },
  {
    name: "Aurora Pizarro",
    role: "Interfaz y modelamiento",
    title: "Arquitecta",
    photo: "/landing/team/aurora-pizarro.png",
  },
  {
    name: "Julio Rodríguez",
    role: "CTO",
    title: "Ingeniero en diseño",
    photo: "/landing/team/julio-rodriguez.png",
  },
  {
    name: "Rodrigo Castro",
    role: "Animación",
    title: "Animador digital",
    photo: "/landing/team/rodrigo-castro.png",
  },
  {
    name: "Anthony Shinomiya",
    role: "Software",
    title: "Ingeniero de software",
    photo: "/landing/team/anthony-shinomiya.png",
  },
  {
    name: "Jorge Sanz-Guerrero",
    role: "Sales development",
    title: "Ingeniero civil",
    photo: "/landing/team/jorge-sanz-guerrero.png",
  },
];

export function SomosPage() {
  return (
    <main className="bg-white pt-26 pb-48 md:pb-64">
      {/* HERO */}
      <section className="py-8 md:py-10">
        <div className="max-w-5xl mx-auto px-4">
          <div className="w-full flex items-center justify-center">
            <SmartImage
              src="/landing/somos/hero.png"
              alt="Somos Metaverso de la Construcción"
              className="
          w-full h-auto 
          max-h-[80dvh]
          object-contain
        "
              width={861}
              height={682}
            />
          </div>
        </div>
      </section>

      {/* TEXTO SOMOS */}
      <section className="py-20 md:py-24">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center space-y-4">
          <h2 className="text-xl md:text-2xl font-bold text-purple-1">
            Somos un equipo multidisciplinario que impulsa a las empresas hacia
            la transformación digital
          </h2>

          <p className="text-base md:text-lg text-black">
            A través de tecnologias inmersivas potenciamos la eficiencia,
            reducimos costos y optimizamos procesos.
          </p>

          <p className="text-base md:text-lg text-black">
            Nuestro objetivo es consolidar a nuestros clientes como referentes
            en innovación y liderazgo en la industria.
          </p>
        </div>
      </section>

      {/* EQUIPO */}
      <section className="py-12 md:py-16">
        <div className="max-w-5xl 2xl:max-w-6xl mx-auto px-4 md:px-4">
          <div className="flex items-center justify-center mb-12 md:mb-20">
            <h3 className="text-4xl md:text-5xl font-bold text-purple-3">
              Equipo
            </h3>
          </div>

          <div className="grid gap-6 gap-y-6 md:gap-y-14 grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {team.map((member) => (
              <article key={member.name} className="text-center space-y-4">
                <div className="aspect-square overflow-hidden">
                  <img
                    src={member.photo}
                    alt={member.name}
                    className="w-full h-full object-cover grayscale"
                  />
                </div>

                <div className="space-y-1">
                  <p className="font-semibold text-base">{member.name}</p>
                  <p className="text-sm text-black/80">{member.role}</p>
                  <p className="text-sm text-black/60">{member.title}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
